


























































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import CreateBillPeriod from "./createbillperiod.vue";
import EditBillPeriod from "./editbillpriod.vue";
import moment from "moment-timezone";
import SearchTree from "@/lib/Common/searchtree";
import checkAuth from "@/lib/Common/checkauth";
import "@/assets/css/table.css";

class PageBillPeriodRequest extends PageRequest {
  keyword: string;
  areaId: number;
  isEnabel: number = 9; //nullable
}

@Component({
  components: { CreateBillPeriod, EditBillPeriod },
})
export default class BillPeriod extends AbpBase {
  edit() {
    this.editModalShow = true;
  }
  //filters
  pagerequest: PageBillPeriodRequest = new PageBillPeriodRequest();
  creationTime: Date[] = [];
  columnlist: any[] = [];
  areaTree: any[] = [];
  areaTreeList: any[] = [];
  searchName: string = "";
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  showcolumn: boolean = false; //显示列选择窗口
  splitnum: number = 0.15;
  //检测按钮权限
  checkButtonAuth(tag: string) {
    return checkAuth.CheckButton(tag);
  }
  get list() {
    return this.$store.state.billperiod.list;
  }
  get loading() {
    return this.$store.state.billperiod.loading;
  }
  create() {
    this.createModalShow = true;
  }
  showcol() {
    this.showcolumn = true;
  }
  isActiveChange(val: number) {
    this.pagerequest.isEnabel = val;
    this.$store.commit("billperiod/setCurrentPage", 1);
    this.getpage();
  }
  getItemId() {
    let item = (this.$refs.tree as any).getSelectedNodes();
    if (item.length > 0) {
      this.pagerequest.areaId = item[0].id;
    }
    this.$store.commit("billperiod/setCurrentPage", 1);
    this.getpage();
  }
  //搜索树形结构
  searchTree(value: any, treeList) {
    if (!value) {
      this.areaTree = this.areaTreeList;
      return;
    }
    //this.treedata = [];
    this.areaTree = SearchTree.searnchTree(value, treeList);
  }
  //区域
  async getAreaTree() {
    await this.$store
      .dispatch("area/getAreaLeftTree")
      .then((val) => {
        this.areaTree = val;
        this.areaTreeList = val;
      })
      .catch((err) => {
        //return null;
      });
  }
  pageChange(page: number) {
    this.$store.commit("billperiod/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("billperiod/setPageSize", pagesize);
    this.getpage();
  }
  async getpage() {
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store.dispatch({
      type: "billperiod/getAll",
      data: this.pagerequest,
    });
  }
  get pageSize() {
    return this.$store.state.billperiod.pageSize;
  }
  get totalCount() {
    return this.$store.state.billperiod.totalCount;
  }
  get currentPage() {
    return this.$store.state.billperiod.currentPage;
  }
  columns = [
    {
      type: "index",
      width: 70,
      align: "center",
      fixed: "left",
      title: this.L("IndexNo"),
      sortId: 0,
    },
    {
      title: this.L("Organizations"),
      key: "organizationId",
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.organizationId;
        let ite = JSON.parse(localStorage.getItem("organizations"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].displayName : this.L("Unknown"),
            },
          },
          info.length > 0 ? info[0].displayName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Areas"),
      key: "areaId",
      sortable: true,
      width: 130,
      render: (h: any, params: any) => {
        let id = params.row.areaId;
        let ite = JSON.parse(localStorage.getItem("areas"));
        let info = ite.filter((p) => {
          return p.id == id;
        });
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: info.length > 0 ? info[0].fullName : this.L("Unknown"),
            },
          },
          info.length > 0 ? info[0].fullName : this.L("Unknown")
        );
      },
    },
    {
      title: this.L("Name"),
      key: "name",
      width: 130,
      fixed: "left",
    },
    {
      title: this.L("BillDayType"),
      key: "dayType",
      width: 130,
      render: (h: any, params: any) => {
        let str = this.L("FixedDate");
        if (params.row.dayType == 2) {
          str = this.L("MonthLastDay");
        } else if (params.row.dayType == 3) {
          str = this.L("MonthFirstDay");
        }
        return h("span", str);
      },
    },
    {
      title: this.L("FirstBillDate"),
      key: "firstBillDate",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.firstBillDate == null
            ? ""
            : moment(params.row.firstBillDate).format("YYYY-MM-DD")
        );
      },
    },
    {
      title: this.L("UpBillDate"),
      key: "upBillDate",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.upBillDate == null
            ? ""
            : moment(params.row.upBillDate).format("YYYY-MM-DD")
        );
      },
    },
    {
      title: this.L("NextBillDate"),
      key: "nextBillDate",
      width: 150,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.nextBillDate == null
            ? ""
            : moment(params.row.nextBillDate).format("YYYY-MM-DD")
        );
      },
    },
    {
      title: this.L("MonthNum"),
      key: "monthNum",
      width: 130,
    },
    {
      title: this.L("LastPayNum"),
      key: "lastPayNum",
      width: 130,
    },
    {
      title: this.L("LateFee"),
      width: 130,
      key: "lateFee",
    },
    {
      title: this.L("IsActive"),
      key: "isEnable",
      width: 90,
      render: (h: any, params: any) => {
        return h(
          "span",
          params.row.isEnable == 1 ? this.L("Yes") : this.L("No")
        );
      },
    },
    {
      title: this.L("IsDefault"),
      key: "isdefault",
      width: 90,
      render: (h: any, params: any) => {
        return h("span", params.row.isdefault ? this.L("Yes") : this.L("No"));
      },
    },
    {
      title: this.L("Description"),
      key: "description",
      width: 130,
      render: (h: any, params: any) => {
        return h(
          "span",
          {
            style: {
              display: "inline-block",
              width: "100%",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            domProps: {
              title: params.row.description,
            },
          },
          params.row.description
        );
      },
    },
    {
      title: this.L("Actions"),
      key: "Actions",
      width: 200,
      fixed: "right",
      render: (h: any, params: any) => {
        let del = this.checkButtonAuth('billperiodDel');
        let edit = this.checkButtonAuth('billperiodEdit');
        let createBills = this.checkButtonAuth('billperiodcreateBills');
        return h("div", [
          createBills ? h(
            "Button",
            {
              props: {
                type: "success",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("CreateBillConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      let res = await this.$store.dispatch({
                        type: "bill/createbills",
                        data: params.row,
                      });
                      this.$Modal.info(res.result);
                      console.log(res);
                    },
                  });
                },
              },
            },
            this.L("CreateBill")
          ) : '',
          edit ? h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  this.$store.commit("billperiod/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          ) : '',
          del ? h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: this.L("Tips"),
                    content: this.L("DeleteConfirm"),
                    okText: this.L("Yes"),
                    cancelText: this.L("No"),
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "billperiod/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            this.L("Delete")
          ) : '',
        ]);
      },
    },
  ];
  async created() {
    this.getpage();
    this.pagerequest.isEnabel = 9;
    this.getAreaTree();
  }
  data() {
    return {
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
